import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '../../environments/environment';

export class AmplitudeEvent {
    eventName: string = '';
    properties: any = {};
}

export enum AMPLITUDE_EVENT_CATEGORIES {
    Onboarding = 'Onboarding',
    Engagement = 'Engagement',
    Subscription = 'Subscription',
    Usage = 'Usage',
    Error = 'Error',
    Expansion = 'Expansion',
}

export enum AMPLITUDE_EVENTS {
    MYCARDS_INSTALL_LINK_CLICKED = 'mycards_install_link_clicked',
    MYCARDS_INSTALL_MODAL_OPENED = 'mycards_install_modal_opened',
    MYCARDS_INSTALLED = 'mycards_installed',
    MYCARDS_EMPTY_STATE_CTA_CLICKED = 'mycards_empty_state_cta_clicked',
    MYCARDS_GO_TO_DASHBOARD_CTA_CLICKED = 'mycards_go_to_dashboard_cta_clicked',
    SHARE_CARD_LINK_CLICKED = 'share_card_link_clicked',
    LOGOUT_INITIATED = 'logout_initiated',
    SWITCH_ORGANIZATION = 'switch_organization',
    MYCARDS_LANDING_PAGE_OPENED_MOBILE = 'mycards_landing_page_opened_mobile',
    MYCARDS_LANDING_PAGE_OPENED_DESKTOP = 'mycards_landing_page_opened_desktop',
    MYCARDS_HOME_PAGE_OPENED = 'mycards_home_page_opened',
    MOBILE_APP_MODAL_DISMISSED = 'mobile_app_modal_dismissed',
    MOBILE_APP_NUDGE_ACTION_CLICKED = 'mobile_app_nudge_action_clicked',
    CARD_MOBILE_APP_INSTALL_CLICKED = 'card_mobile_app_install_clicked',
}

@Injectable()
export class AmplitudeService {
    userId: string;
    isOpenedAsPWA: boolean;
    isMobile: boolean;

    constructor(private authService: AuthService) {
        this.authService.isLoggedIn$.subscribe((loggedIn) => {
            if (loggedIn) {
                this.userId = this.authService.getUser().id.toString();
            } else {
                this.userId = '000000';
            }
            amplitude.init(environment.amplitudeAPIKey, this.userId, {
                autocapture: false,
            });
        });

        this.authService.isOpenedAsPWA$.subscribe((isPwa) => {
            this.isOpenedAsPWA = isPwa;
        });

        this.authService.isMobileDevice$.subscribe((isMobile) => {
            this.isMobile = isMobile;
        });
    }

    logEvent(
        category: AMPLITUDE_EVENT_CATEGORIES,
        event: string,
        eventProperties: object = null
    ) {
        if (!category) {
            throw new Error('category is required');
        }

        amplitude.logEvent(event, eventProperties);
    }

    setAmplitudeEventProperties() {
        return this.isOpenedAsPWA ? 'pwa' : 'browser';
    }

    setDeviceProperties() {
        return this.isMobile ? 'mobile' : 'desktop';
    }
}
